module.exports = __webpack_public_path__ + "static/media/product_oil.d614e3ff.png";